// "Sign out everywhere" for ONE person, as an administrator (Session ASB, Item 3). Ends every session they hold on the
// server, office, admin, engineer or auditor alike, without touching the account: the lever for a lost phone, a shared
// password or a suspicion (Deactivate is the one that takes the account away). The branded two-step confirm names
// the person; the result is said inline beside the button. Admin only on the server; each page shows it only to an
// admin.
//
// IT ENDS BROWSER AND PHONE SIGN-INS ONLY (Session ASB review, finding F8). A Connected AI connection (an OAuth grant
// or a connection token) is a separate credential that this does not touch: only a deactivation, or removing the
// connection on the Connected AI page, ends one. The confirm and the result both say so, in plain English, so an
// administrator acting on a suspicion is not left believing every way in has been closed.
import { useState } from "react";
import { api } from "../../lib/api";
import { ConfirmButton } from "../../components/ConfirmButton";

export const CONNECTED_AI_NOTE = "Connected AI connections are separate: manage them on the Connected AI page.";

export function SignOutEverywhereButton({ userId, name, className = "" }: { userId: string; name: string; className?: string }) {
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState<{ ok: boolean; text: string } | null>(null);

  async function run() {
    setBusy(true);
    setResult(null);
    try {
      const res = await api.admin.revokeUserSessions(userId);
      setResult({
        ok: true,
        text: `${res.revoked > 0 ? `${name} is signed out on every device.` : `${name} was not signed in anywhere.`} ${CONNECTED_AI_NOTE}`,
      });
    } catch {
      setResult({ ok: false, text: "Could not sign them out. Please try again." });
    } finally {
      setBusy(false);
    }
  }

  return (
    <>
      <ConfirmButton
        onConfirm={() => void run()}
        label="Sign out everywhere"
        confirmLabel={`Sign ${name} out on every device? Connected AI stays connected.`}
        busy={busy}
        busyLabel="Signing out..."
        resetMs={6000}
        className={`rounded-ele border border-ele-purple-accent px-2.5 py-1 text-xs text-ele-body transition hover:border-ele-danger hover:text-ele-strong disabled:opacity-50 ${className}`.trim()}
      />
      {result && (
        <span role={result.ok ? "status" : "alert"} className={`text-xs ${result.ok ? "text-ele-green" : "text-ele-danger"}`}>
          {result.text}
        </span>
      )}
    </>
  );
}
